import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Hero from './components/Hero';
import ServicesOverview from './components/ServicesOverview';
import Advantages from './components/Advantages';
import Cases from './components/Cases';
import Partners from './components/Partners';
import FAQ from './components/FAQ';
import ContactCTA from './components/ContactCTA';

export default function Home() {
  return (
    <>
      <SEOHead
        title="征途国际 - 全球征途，无限可能"
        description="征途国际为您提供一站式国际化服务，涵盖全球市场拓展、跨境业务合作与国际资源对接。无论您的征途目标在哪里，征途国际都是您走向世界的最强合作伙伴。"
        keywords="征途国际,征途国际官网,征途国际合作,征途国际全球服务,跨境国际业务,国际市场拓展,全球资源对接,国际化战略合作"
        canonicalUrl="https://exportr.github.io"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': '征途国际 - 首页',
          'description': '征途国际为您提供一站式国际化服务，涵盖全球市场拓展、跨境业务合作与国际资源对接。',
          'url': 'https://exportr.github.io',
          'isPartOf': {
            '@type': 'WebSite',
            'name': '征途国际',
            'url': 'https://exportr.github.io',
          },
        }}
      />

      <Navbar />

      <main>
        <Hero />
        <ServicesOverview />
        <Advantages />
        <Cases />
        <Partners />
        <FAQ />
        <ContactCTA />
      </main>

      <Footer />
    </>
  );
}